import { Fragment } from 'react/jsx-runtime';
import { ColoredImageIcon } from '@room-match/shared-ui-components';
import { FileType } from 'shared/enums/FileType';
import { MediaFileType } from 'shared/enums/MediaFileType';
import { useEditProfileMediaDocumentData } from '../../hooks/useEditProfileMediaDocumentData';
import { ImageThumbnailContainer } from 'pages/Representatives/components/ImageThumbnail';
import { array_skeletons } from 'pages/Representatives/const/array_skeleton';
import { EditProfileCustomSkeleton } from '../../EditProfile.styles';
import { EditProfileDocumentsImageListContainer } from './EditProfileMediaDocumentsImage.styles';
import EditProfileMediaDocumentAccordion from '../EditProfileMediaDocumentAccordion/EditProfileMediaDocumentAccordion';
import EditProfileMediaDocumentHidden from './EditProfileMediaDocumentHidden/EditProfileMediaDocumentHidden';
import EditProfileMediaDocumentDivider from '../EditProfileMediaDocumentDivider/EditProfileMediaDocumentDivider';
import EditProfileDocumentAttached from './EditProfileDocumentAttached/EditProfileDocumentAttached';
import RepresentativeErrorUI from 'pages/Representatives/components/RepresentativeErrorUI/RepresentativeErrorUI';

const EditProfileMediaDocumentsImage = () => {
  const {
    attached_media: attached_images,
    hidden_media,
    completeness,
    media_loading,
    media_error,
    handleRefetch,
  } = useEditProfileMediaDocumentData(FileType.IMAGE);

  return (
    <EditProfileMediaDocumentAccordion
      type={FileType.IMAGE}
      used_length={attached_images?.length || 0}
      max_length={(hidden_media?.length || 0) + (attached_images?.length || 0)}
      header_icon={<ColoredImageIcon />}
      completeness={completeness}
    >
      {media_loading ? (
        <EditProfileDocumentsImageListContainer>
          {array_skeletons.map((_, index) => (
            <ImageThumbnailContainer key={index}>
              <EditProfileCustomSkeleton width="100%" height="100%" variant="rect" />
            </ImageThumbnailContainer>
          ))}
        </EditProfileDocumentsImageListContainer>
      ) : media_error ? (
        <RepresentativeErrorUI message={'There was a problem getting your Image/s'} onButtonClick={handleRefetch} />
      ) : (
        <Fragment>
          <EditProfileDocumentAttached attached_medias={attached_images} fileType={FileType.IMAGE} />
          {hidden_media?.length === 0 ? null : (
            <EditProfileMediaDocumentDivider type={MediaFileType.IMAGE}>
              <EditProfileMediaDocumentHidden fileType={FileType.IMAGE} hidden_media={hidden_media} />
            </EditProfileMediaDocumentDivider>
          )}
        </Fragment>
      )}
    </EditProfileMediaDocumentAccordion>
  );
};

export default EditProfileMediaDocumentsImage;
